import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	width: 430px;
	padding: 30px 30px 0 0;
`;

const StyledPresetsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 40px;
	column-gap: 10px;
`;

const StyledPresetButtonContainer = styled.div<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.1);
	cursor: pointer;
	transition: background-color 0.3s ease;

	${Text} {
		color: #ffffff;
		font-size: 16px;
		font-weight: 400;
		transition: color 0.3s ease;
	}

	img {
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${(props) =>
		props.$active
			? css`
					background-color: #2d70da;
			  `
			: css`
					&:hover {
						background-color: #ffffff;

						${Text} {
							color: #000000;
						}

						img {
							filter: invert(100%);
						}
					}
			  `}
`;

const StyledSettingsCategoryHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledSettingsCategoryName = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;

	img {
		opacity: 0.75;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		color: #ffffff;
		opacity: 0.75;
		font-size: 16px;
		font-weight: 400;
	}
`;

const StyledResetButton = styled.button.attrs({
	tabIndex: -1,
})`
	width: 65px;
	height: 20px;
	border-radius: 6px;
	background-color: rgba(255, 255, 255, 0.1);
	color: #fff;
	font-family: GT Walsheim Pro;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	border: none;
	cursor: pointer;
	user-select: none;

	transition: all 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

const StyledSettingsContainer = styled.div`
	height: 650px;
	overflow-y: scroll;
	width: 430px;
	padding-right: 20px;

	&::-webkit-scrollbar {
		width: 10px;
	}

	/* Track */
	&::-webkit-scrollbar-track {
		background-color: transparent;
	}

	/* Handle */
	&::-webkit-scrollbar-thumb {
		background-color: rgba(255, 255, 255, 0.1);
	}

	/* Handle on hover */
	&::-webkit-scrollbar-thumb:hover {
		background-color: #ffffff;
	}
`;

const StyledPanelControlsContainer = styled.div`
	margin-top: 40px;
`;

const StyledPopupContainer = styled.div`
	position: absolute;
	//top: 50px;
	right: -85px;
	z-index: 6;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.9);
	opacity: 0;
	transition: opacity 0.3s ease;

	${Text} {
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}

	&.popup-enter {
		opacity: 0;
	}

	&.popup-enter-active,
	&.popup-enter-done,
	&.popup-exit {
		opacity: 1;
	}

	&.popup-exit-active {
		opacity: 0;
	}
`;

export {
	StyledContainer,
	StyledPanelControlsContainer,
	StyledPopupContainer,
	StyledPresetButtonContainer,
	StyledPresetsContainer,
	StyledResetButton,
	StyledSettingsCategoryHead,
	StyledSettingsCategoryName,
	StyledSettingsContainer,
};
